import { first, has, isArray } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'

export interface SearchCountryOutput extends BaseOutput {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Nazioni: NazioneData[]
}

export interface NazioneData {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CodiceNazione: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Descrizione: string
  // eslint-disable-next-line @typescript-eslint/naming-convention
  SiglaNazione: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNazioneData = (obj: any): obj is NazioneData =>
  obj && has(obj, 'CodiceNazione') && has(obj, 'Descrizione') && has(obj, 'SiglaNazione')

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isNazioneDataArr = (obj: any): obj is NazioneData[] => {
  if (isArray(obj)) {
    if (obj.length) {
      return isNazioneData(first(obj))
    }
    return true
  }
  return false
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isSearchCountryOutput = (obj: any): obj is SearchCountryOutput =>
  has(obj, 'Nazioni') && isNazioneDataArr(obj.Nazioni) && isBaseOutput(obj)
